import { email, Edit, SimpleForm,
  TextInput, BooleanInput, Create,
  required, ShowButton, TopToolbar,
  CreateProps, EditActionsProps, EditProps } from "react-admin";
import { OrdersLink, phoneValidation, plusParseFormat, ShowTitle, SubscriptionsLink } from "../shared-components";


const validateEmail = [required(), email('Must be a valid Email')];
const validatePhone = [required(), phoneValidation];
const requiredField = required();

const CustomerEditActions = ({ basePath, data }:EditActionsProps) => (
  <TopToolbar>
    <OrdersLink href={`https://backoffice.gopuff.com/orders?user_id=${data?.rails_id}`}/>
    <SubscriptionsLink href={`https://backoffice.gopuff.com/subscriptions?user_id=${data?.rails_id}`}/>
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

export const CreateCustomer: React.FC<CreateProps> = (props) =>
  (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="email" type="email" label="Email" validate={validateEmail} variant="outlined" />
        <TextInput source="phone" type="text" label="Phone" validate={validatePhone} variant="outlined" parse={plusParseFormat}/>
        <TextInput source="first_name" type="text" label="First name" validate={requiredField} variant="outlined"/>
        <TextInput source="last_name" type="text" label="Last name" validate={requiredField} variant="outlined"/>
      </SimpleForm>
    </Create>
  );
export const EditCustomer: React.FC<EditProps> = (props) =>
  (
    <Edit title={<ShowTitle/>} mutationMode="pessimistic" actions={<CustomerEditActions />} {...props}>
      <SimpleForm warnWhenUnsavedChanges>
        <TextInput source="email" type="email" label="Email" validate={validateEmail} variant="outlined"/>
        <TextInput source="phone" type="text" label="Phone" validate={validatePhone} variant="outlined" parse={plusParseFormat}/>
        <TextInput source="first_name" type="text" label="First name" validate={requiredField} variant="outlined"/>
        <TextInput source="last_name" type="text" label="Last name" validate={requiredField} variant="outlined"/>
        <TextInput source="points" type="number" label="Points" variant="outlined"/>
        <BooleanInput source="active" label="ACTIVE CUSTOMER" variant="outlined"/>
      </SimpleForm>
    </Edit>
  );
